export const SUPPLIER_CREATE = 'supplierCreate'
export const SUPPLIER_EDIT = 'supplierEdit'
export const SUPPLIER_DELETE = 'supplierDelete'
export const SUPPLIER_GET = 'supplierGet'
export const SUPPLIERS_GET = 'suppliersGet'
export const SUPPLIER_SEARCH = 'supplierSearch'
export const SUPPLIER_ACTIVE = 'supplierActive'
export const SUPPLIER_INACTIVE = 'supplierInactive'
    